import { render, staticRenderFns } from "./ConfirmMail.vue?vue&type=template&id=b93de2ea"
import script from "./ConfirmMail.vue?vue&type=script&lang=js"
export * from "./ConfirmMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports